import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from "vue-router";
import HomeView from "../views/HomeView.vue";
import dashboard from "@/components/dashboard.vue";
import fileUpload from "@/components/fileUpload.vue";
import selector from "@/components/selector.vue";
import pdfform from "@/components/pdfform.vue";
import user_detail from "@/components/user_detail.vue";
import user_registration_form from "@/components/user_registration_form.vue";
import nurseActivity from "@/components/nurseActivity.vue";
import adminDashboard from "@/components/adminDashboard.vue";
import qrScan from "@/components/qrScan.vue";
import GenPDF from "@/components/GenPDF.vue";
import student_PLO from "@/views/student_PLO.vue";
import PLO from "@/components/PLO.vue";
import Report from "@/components/Report.vue";
import Academic_Result from "@/views/Academic_Result.vue";
import reset_password from "@/views/reset_password.vue";
import { useAuthStore } from "@/stores/auth";
import alumni from "@/views/alumni.vue";
import CheckStatus from "@/views/CheckStatus.vue";
import alumniStatus from "@/views/alumniStatus.vue";
import AlumniDetail from "@/views/AlumniDetail.vue";
import AddStudent from "@/views/AddStudent.vue";
import clockControl from "@/views/clockControl.vue";
import clockDisplay from "@/views/clock/clockDisplay.vue";
const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/storage",
    name: "storage",
    component: fileUpload,
    meta: { requiresAuth: true },
  },
  {
    path: "/Report",
    name: "Report",
    component: Report,
    meta: { requiresAuth: true },
  },

  {
    // Catch-all route for 404s
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
  {
    path: "/selector",
    name: "selector",
    component: selector,
    meta: { requiresAuth: true },
  },
  {
    path: "/pdfform",
    name: "pdfform",
    component: pdfform,
    meta: { requiresAuth: true },
  },
  {
    path: "/user_detail",
    name: "user_detail",
    component: user_detail,
    meta: { requiresAuth: true },
  },
  {
    path: "/user_registration_form",
    name: "user_registration_form",
    component: user_registration_form,
  },
  {
    path: "/nurseActivity",
    name: "nurseActivity",
    component: nurseActivity,
    meta: { requiresAuth: true },
  },
  {
    path: "/adminDashboard",
    name: "adminDashboard",
    component: adminDashboard,
    meta: { requiresAuth: true, requiredRole: ["admin", "subadmin"] },
  },
  {
    path: "/qrScan",
    name: "qrScan",
    component: qrScan,
    meta: { requiresAuth: true, requiredRole: "admin" },
  },
  {
    path: "/genPDF",
    name: "GenPDF",
    component: GenPDF,
    meta: { requiresAuth: true },
  },
  {
    path: "/student_PLO",
    name: "student_PLO",
    component: student_PLO,
    meta: { requiresAuth: true },
  },
  {
    path: "/Academic_Result",
    name: "Academic_Result",
    component: Academic_Result,
    meta: { requiresAuth: true },
  },
  {
    path: "/add_PLO",
    name: "add_PLO",
    component: PLO,
    meta: { requiresAuth: true, requiredRole: "admin" },
  },
  {
    path: "/reset_password",
    name: "reset_password",
    component: reset_password,
  },
  // {
  //   path: "/OSCE",
  //   name: "OSCE",
  //   component: OSCE,
  // },
  {
    path: "/addStudent",
    name: "addStudent",
    component: AddStudent,
    meta: { requiresAuth: true, requiredRole: ["admin", "subadmin"] },
  },
  {
    path: "/alumni",
    name: "alumni",
    component: alumni,
  },
  {
    path: "/check_status",
    name: "check_status",
    component: CheckStatus,
  },
  {
    path: "/alumniStatus",
    name: "alumniStatus",
    component: alumniStatus,
  },
  {
    path: "/alumniDetail",
    name: "alumniDetail",
    meta: { requiresAuth: true },
    component: AlumniDetail,
  },
  {
    path: "/clockControl",
    name: "clockControl",
    component: clockControl,
  },
  {
    path: "/clockDisplay",
    name: "clockDisplay",
    component: clockDisplay,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();
  // 4. Handle role-based access control
  const requiredRole = to.meta.requiredRole;
  // const requiredRoles = to.meta.requiredRoles;
  const userRole = authStore.userRole;
  document.title = "ฐานข้อมูลศิษย์เก่า-คณะพยาบาลศาสตร์ มหาวิทยาลัยปทุมธานี";

  // 1. ALWAYS initialize the auth state and wait for the async check to complete
  await authStore.initializeAuth();

  // 2. Handle redirection for authenticated users trying to access the login page (path: "/")
  if (to.path === "/" && authStore.isAuthenticated) {
    return next("/user_detail");
  }

  if (to.path === "/user_detail" && userRole == "admin") {
    return next("/adminDashboard");
  }

  // 3. Handle protected routes for unauthenticated users
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    // If not authenticated, clear UI state and redirect to login
    authStore.drawer = false;
    authStore.rail = false;
    return next("/");
  }

  if (requiredRole) {
    if (Array.isArray(requiredRole)) {
      if (!requiredRole.includes(userRole)) {
        return next("/user_detail");
      }
    } else if (userRole !== requiredRole) {
      return next("/user_detail");
    }
  }

  // 5. Proceed with navigation
  next();
});

export default router;
